import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-application-development-approach',
  templateUrl: './application-development-approach.component.html',
  styleUrls: ['./application-development-approach.component.sass']
})
export class ApplicationDevelopmentApproachComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
